
import { Box, ListItem, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import ActionMenu from "../../components/action-menu/ActionMenu";
import { useTranslation } from "react-i18next";
import { ActionMenuItem } from "../action-menu/ActionMenuItem";
import { Square } from "@mui/icons-material";
import { useMemo } from "react";
import { AlarmSchemeListActionEnum } from "./AlarmSchemeListUtils";
import { IeLynxObject } from "../../common/models/eLynxObject";

export type AlarmSchemeUsageListItemProps = {
    item: IeLynxObject,
    onAction: (action: AlarmSchemeListActionEnum, payload: IeLynxObject) => void,
};

export function AlarmSchemeUsageListItem({
    item,
    onAction,
}: AlarmSchemeUsageListItemProps) {

    const { t } = useTranslation();
    const theme = useTheme();

    const actionItems: ActionMenuItem[] = useMemo(() => {

        const actions: ActionMenuItem[] = [{
            label: t("setpointAdmin.actions.edit"),
            action: AlarmSchemeListActionEnum.EditSetpoint,
            onClick: () => {onAction(AlarmSchemeListActionEnum.EditSetpoint, item)}, 
            order: 0
        }];    
    
        return actions;

    }, [
        t,
        item,
        onAction
    ]);


    return (
        <ListItem disablePadding >
            <ListItemIcon sx={{fontSize: ".4rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                <Square fontSize="inherit"/>
            </ListItemIcon>
            <ListItemText 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 0
                }}
                primary={
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: '1 1 auto',
                                overflow: 'hidden'
                            }}>
                            {item.displayText}
                        </Box>

                        {
                        actionItems.length ?

                            <Box sx={{
                                display: 'flex'
                            }}>
                                <ActionMenu
                                    actionItems={actionItems}
                                />
                            </Box>
                            : null
                        }
                    </>
                } 
            
                slotProps={{
                    primary: {
                        component: 'div',
                        sx: {
                            fontSize: '.9rem',
                            display: 'flex',
                            color: theme.palette.grey[600]
                        }
                    }
                }} 
            />
        </ListItem>
    );
}
